import axios from 'axios';

const suggestResult = {
    suggestions: [
        {
            text: '',
            magicKey: 'hash',
            isCollection: false
        }
    ]
};

const findAddressCandidatesResult = {
    spatialReference: {
        wkid: 0,
        latestWkid: 0
    },
    candidates: [
        {
            address: 'Montana',
            location: {
                x: 0.0,
                y: 0.0
            },
            score: 100,
            attributes: {
                Addr_type: '',
                type: ''
            },
            extent: {
                xmin: 0.0,
                ymin: 0.0,
                xmax: 0.0,
                ymax: 0.0
            }
        }
    ]
};

const geoCodeServerUrl = 'https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/';
const apikey = 'AAPK7cc20300953040748c0b229f9d3e53c5I6whnLOLVBc8bX1VpYkrCmjL2FEfsYmOCZMSA1YUpWs2FDi4h8BiOU5-VqB49S-v';

export const onemapSuggest = async (text, extent) => {
    const creds = apikey;
    return axios.get(`${geoCodeServerUrl}/suggest?f=json&countryCode=USA&category=Address,Primary Postal,City,Subregion,Region&maxSuggestions=10&text=${text}&searchExtent=${extent}&token=${creds}`).then((data) => {
        return data;
    });
};

export const onemapFindAddress = async (magicKey, extent) => {
    const creds = apikey;
    //note change outfields to * to see all outfields
    return axios.get(`${geoCodeServerUrl}/findAddressCandidates?f=json&countryCode=USA&outFields=Addr_type,Type&magicKey=${magicKey}&searchExtent=${extent}&token=${creds}`).then((data) => {
        return data;
    });
};

export const getAddressCandidateScale = (candidate, view) => {
    const { Addr_type, Type } = candidate.attributes;
    const slug = String(Addr_type + '_' + Type)
        .toLowerCase()
        .replace(/ /g, '_')
        .replace(/__/g, '_')
        .replace(/_$/, '');
    console.log(view, '==', slug);
    switch (slug) {
        case 'subaddress':
        case 'pointaddress':
        case 'streetaddress':
        case 'streetint':
        case 'streetaddressext':
        case 'distancemarker':
        case 'poi':
        case 'latlong':
        case 'xy':
        case 'yx':
        case 'streetmidblock':
        case 'streetbetween':
        case 'locality_block':
        case 'streetname':
        case 'locality_sector':
        case 'locality_neighborhood':
        case 'locality_district':
        case 'postalloc':
        case 'postalext':
        case 'postal':
            return view === 'deaths' ? 'census' : 'zcta';
        case 'locality_city':
        case 'locality_metroarea':
        case 'locality_county':
            return 'county';
        case 'locality_state_or_province':
        case 'locality_territory':
        case 'locality_country':
        case 'locality_zone':
            return 'usstate';
        default:
            return 'usstate';
    }
};
export const testAddressCandidateScale = () => {
    var views = ['deaths', 'ed_visits'];
    var times = ['ttm', '2023', '2022', '2021', '2020', '2019'];
    var searchResultPossibilities = [
        { Addr_type: 'Subaddress', Type: '' },
        { Addr_type: 'PointAddress', Type: '' },
        { Addr_type: 'StreetAddress', Type: '' },
        { Addr_type: 'StreetInt', Type: '' },
        { Addr_type: 'StreetAddressExt', Type: '' },
        { Addr_type: 'DistanceMarker', Type: '' },
        { Addr_type: 'POI', Type: 'POI Type' },
        { Addr_type: 'LatLong', Type: '' },
        { Addr_type: 'XY', Type: '' },
        { Addr_type: 'YX', Type: '' },
        { Addr_type: 'StreetMidBlock', Type: '' },
        { Addr_type: 'StreetBetween', Type: '' },
        { Addr_type: 'Locality', Type: 'Block' },
        { Addr_type: 'StreetName', Type: '' },
        { Addr_type: 'Locality', Type: 'Sector' },
        { Addr_type: 'Locality', Type: 'Neighborhood' },
        { Addr_type: 'Locality', Type: 'District' },
        { Addr_type: 'PostalLoc', Type: '' },
        { Addr_type: 'PostalExt', Type: '' },
        { Addr_type: 'Postal', Type: '' },
        { Addr_type: 'Locality', Type: 'City' },
        { Addr_type: 'Locality', Type: 'MetroArea' },
        { Addr_type: 'Locality', Type: 'County' },
        { Addr_type: 'Locality', Type: 'State or Province' },
        { Addr_type: 'Locality', Type: 'Territory' },
        { Addr_type: 'Locality', Type: 'Country' },
        { Addr_type: 'Locality', Type: 'Zone' }
    ];

    searchResultPossibilities.forEach((candidate) => {
        views.forEach((view) => {
            const scale = getAddressCandidateScale({ attributes: candidate }, view);
            console.log('scale==>', scale);
        });
    });
};
